import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "./axios";
import { reArangeFilters } from "../utils/index";
export const getContributors = createAsyncThunk("contributor", async () => {
	try {
		const response = await axios.get("/contributor/search");
		return response.data;
	} catch (error: any) {
		console.log(error?.message, "error", error);
	}
});

export const getContributorsBySearch = async (filters: any) => {
	try {
		const queryFilters = reArangeFilters(filters);
		const response = await axios.get("/contributor/search"+queryFilters);
		return response.data;
	} catch (error: any) {
		console.log(error?.message, "error", error);
	}
};

export const saveContributor = createAsyncThunk(
	"save/contributor",
	async (data: any, thunkAPI) => {
		try {
			const response = await axios.post("/contributor", data);
			return response.data;
		} catch (error: any) {
			console.log(error?.message, "error", error);
			return thunkAPI.rejectWithValue({ error: error.message });
		}
	}
);

export const updateContributorProfile = createAsyncThunk(
	"update/contributor/profile",
	async (data: any, thunkAPI) => {
		try {
			const response = await axios.patch("/contributor/" + data.id, data);
			return response.data;
		} catch (error: any) {
			console.log(error?.message, "error", error);
			return thunkAPI.rejectWithValue({ error: error.message });
		}
	}
);

export const getContributorArtists = createAsyncThunk("contributor/artists", async () => {
	try {
		const response = await axios.get("/contributor/artists");
		return response.data;
	} catch (error: any) {
		console.log(error?.message, "error", error);
	}
});

export const saveContributorArtist = createAsyncThunk(
	"contributor/save/artist",
	async (data: any, thunkAPI) => {
		try {
			const response = await axios.post("/artistRoyaltyRevenue/save/artist", data);
			return response.data;
		} catch (error: any) {
			console.log(error?.message, "error", error);
			return thunkAPI.rejectWithValue({ error: error.message });
		}
	}
);

export const updateManyArtistRoyaltyRevenue = createAsyncThunk(
	"update/many/artistRoyaltyRevenue",
	async (data: any, thunkAPI) => {
		try {
			const response = await axios.patch(
				"/artistRoyaltyRevenue/update/many",
				data
			);
			return response.data;
		} catch (error: any) {
			console.log(error?.message, "error", error);
			return thunkAPI.rejectWithValue({ error: error.message });
		}
	}
);

export const getArtistRoyaltyRevenueDetail = createAsyncThunk(
	"/api/ArtistRoyaltyRevenue/{id}",
	async (data: any, thunkAPI) => {
		try {
			const response = await axios.get("/artistRoyaltyRevenue/" + data);
			return response.data;
		} catch (error: any) {
			console.log(error?.message, "error", error);
			return thunkAPI.rejectWithValue({ error: error.message });
		}
	}
);

export const updateArtistRoyaltyRevenue = createAsyncThunk(
	"update/ArtistRoyaltyRevenue/{id}",
	async (data: any, thunkAPI) => {
		try {
			const response = await axios.patch(
				"/artistRoyaltyRevenue/" + data.id,
				data
			);
			return response.data;
		} catch (error: any) {
			console.log(error?.message, "error", error);
			return thunkAPI.rejectWithValue({ error: error.message });
		}
	}
);

export const getArtistRoyaltyRevenueContributions = createAsyncThunk(
	"get/artistRoyaltyRevenueContributions",
	async (filters: any, thunkAPI) => {
		try {
			const queryFilters = reArangeFilters(filters);
			const response = await axios.get(`/artistRoyaltyRevenue${queryFilters}`);
			return response.data;
		} catch (error: any) {
			console.log(error?.message, "error", error);
		}
	}
);

export const saveArtistRoyaltyRevenueReminder = createAsyncThunk(
	"update/artistRoyaltyRevenue/reminder",
	async (data: any, thunkAPI) => {
		try {
			const response = await axios.post("/artistRoyaltyRevenue/reminder", data);
			return response.data;
		} catch (error: any) {
			console.log(error?.message, "error", error);
			return thunkAPI.rejectWithValue({ error: error.message });
		}
	}
);
